import { SwipeDirection } from '../enums/swipeEnums.js';

var horizontalDirections = [SwipeDirection.Left, SwipeDirection.Right];

export { horizontalDirections };
